import { FC } from "react";
import Popup from "reactjs-popup";

interface CustomLoaderProps {
    isVisible: boolean;
}

const CustomLoader: FC<CustomLoaderProps> = (props) => {
    return (
        <Popup
            open={props.isVisible}
            modal
            overlayStyle={{
                zIndex: 999999,
                backgroundColor: "rgba(0, 0, 0, 0.4)",
                backdropFilter: "blur(3px)",
                WebkitBackdropFilter: "blur(3px)",
            }}
            closeOnDocumentClick={false}
            closeOnEscape={false}
        >
            <div className="flex justify-center">
                <div
                    className="w-30 h-30 border-[16px] rounded-full fixed top-[47.5%] animate-spin"
                    style={{
                        width: "120px",
                        height: "120px",
                        borderWidth: "12px",
                        borderStyle: "solid",
                        borderColor: "gray transparent transparent transparent",
                    }}
                ></div>
            </div>
        </Popup>
    );
};

export default CustomLoader;
